import ThemedSelect from "../shared/ThemedSelect.jsx";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { todayInput, monthStart } from "../../utils/date.js";

// Shared bits for the Predefined Searches pages — one look across all of them:
// page-panel + heading, a compact labelled filter (search-page style), NZD
// money, and a claim-number link into the workspace.

export const nzd = new Intl.NumberFormat("en-NZ", { style: "currency", currency: "NZD" });
export const money = (v) => nzd.format(Number(v || 0));

export function FilterSelect({ label, value, onChange, options, width = 180, labelField = "name", children }) {
  return (
    <div style={{ width }}>
      <Form.Label className="mb-1 small text-muted">{label}</Form.Label>
      <ThemedSelect size="sm" value={value || ""} onChange={(e) => onChange(e.target.value)}>
        <option value="">All</option>
        {children}
        {(options || []).map((o) => (
          <option key={o.id} value={o.id}>{o[labelField]}</option>
        ))}
      </ThemedSelect>
    </div>
  );
}

export function FilterDate({ label, value, onChange, type = "date", width = 150 }) {
  return (
    <div style={{ width }}>
      <Form.Label className="mb-1 small text-muted">{label}</Form.Label>
      <Form.Control size="sm" type={type} value={value || ""} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}

export function ClaimLink({ claimId, claimNumber, tab = null }) {
  const navigate = useNavigate();
  return (
    <span
      role="button"
      className="text-primary text-decoration-underline"
      // Claim URLs carry the NUMBER (the id form still lands via the claim
      // GET's fallback, so a caller with only an id keeps working).
      onClick={() => navigate(`/claims/${claimNumber ?? claimId}${tab ? `?tab=${tab}` : ""}`)}
    >
      {claimNumber}
    </span>
  );
}

// First of the previous month (the legacy default start date).
// NZ-zone-aware (utils/date.js). The old toISOString() versions returned
// YESTERDAY for the whole NZ morning — reports defaulting `to: today()` were
// silently dropping today's rows until ~noon (phase1-review Wave 1).
export const firstOfLastMonth = () => monthStart(-1);

export const today = () => todayInput();
